// Motore "quality tier": la fluidità è la priorità assoluta.
// Rileva memoria/CPU/preferenze e sceglie 3 livelli (high/medium/low) che riducono
// automaticamente particelle, ghost e effetti pesanti su smartphone di fascia media/bassa.
// Espone anche un guard FPS che declassa il tier a runtime se il frame rate crolla.

const nav = typeof navigator !== "undefined" ? navigator : {};
const mem = nav.deviceMemory || 4;
const cores = nav.hardwareConcurrency || 4;
const reduce = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

let tier = "high";
if (reduce || mem <= 2 || cores <= 2) tier = "low";
else if (mem <= 4 || cores <= 4) tier = "medium";

const PARTICLES = { high: 12, medium: 6, low: 0 };
const MAX_GHOSTS = { high: 14, medium: 6, low: 3 };

export const PERF = {
  get tier() { return tier; },
  reduce,
  get particles() { return PARTICLES[tier]; },
  get maxGhosts() { return MAX_GHOSTS[tier]; },
  get heavyGlow() { return tier === "high"; },
};

export const scaleGhosts = (n) => Math.min(Math.max(0, n | 0), PERF.maxGhosts);

export function applyPerfClass() {
  if (typeof document === "undefined") return;
  document.body.classList.remove("perf-high", "perf-medium", "perf-low");
  document.body.classList.add(`perf-${tier}`);
}

// Guard FPS: se la media scende sotto ~40fps per qualche secondo, declassa il tier
// (high→medium→low) e riapplica la classe, così l'esperienza resta fluida.
let guardStarted = false;
export function startFpsGuard(onDowngrade) {
  if (guardStarted || reduce || typeof requestAnimationFrame === "undefined") return;
  guardStarted = true;
  let frames = 0, last = performance.now(), lowStreak = 0;
  const loop = (now) => {
    frames++;
    if (now - last >= 1000) {
      const fps = frames * 1000 / (now - last);
      frames = 0; last = now;
      if (fps < 40) lowStreak++; else lowStreak = 0;
      if (lowStreak >= 3 && tier !== "low") {
        tier = tier === "high" ? "medium" : "low";
        lowStreak = 0;
        applyPerfClass();
        onDowngrade && onDowngrade(tier);
      }
    }
    if (!document.hidden) requestAnimationFrame(loop); else guardStarted = false;
  };
  requestAnimationFrame(loop);
}

// Fase giorno/notte in base all'ora locale (per tint atmosferico della mappa).
export function dayPhase(d = new Date()) {
  const h = d.getHours();
  if (h >= 6 && h < 9) return "dawn";
  if (h >= 9 && h < 18) return "day";
  if (h >= 18 && h < 21) return "dusk";
  return "night";
}
